import tinycolor from "tinycolor2";
const determineTextColor = (backgroundColor, idealTextColor) => {
  if (tinycolor.readability(idealTextColor, backgroundColor) >= 3) {
    return idealTextColor;
  }
  return tinycolor.mostReadable(backgroundColor, ["#000", "#fff"]).toHexString();
};
export {
  determineTextColor
};
//# sourceMappingURL=Color.mjs.map